import { render } from "./modalContact.vue?vue&type=template&id=ec19bc5e"
import script from "./modalContact.vue?vue&type=script&lang=js"
export * from "./modalContact.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wojtek/web/customer-zone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__